import React, { useState, useEffect } from 'react';
import moment from 'moment-timezone';

function useTimeZoneClock(date) {
  const [currentTime, setCurrentTime] = useState(
    moment(date).tz('America/Denver').format('HH:mm:ss')
  );

  useEffect(() => {
      setCurrentTime(
        // moment(date).tz('America/Denver').format(' hh:mm:ss')
        moment.utc(date, "DD-MM-YYYY HH:mm").tz("America/Denver").format("YYYY-MM-DD HH:mm")
    );
  }, []);

  return currentTime
}

export default useTimeZoneClock;
